module.exports = __webpack_public_path__ + "img/logo.1110e5ba.png";